"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var EducationalService_1 = __importDefault(require("./EducationalService"));
exports.EducationalService = EducationalService_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9iZWxsdXMvRW5yb2xsbWVudEFncmVlbWVudEZvcm0vcGFydHMvU2VjdGlvbjEvRWR1Y2F0aW9uYWxTZXJ2aWNlL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsNEVBQXFEO0FBRTdDLDZCQUZELDRCQUFrQixDQUVDIn0=